export default __webpack_public_path__ + "static/ak-cached/24h/media/max.4d34b172.png";